module.exports = __webpack_public_path__ + "static/MP-Melvin-23c1943dc9a9e32cd65540a28900675c.png";